import {
  renderCardSection,
  renderAnyHitDetails,
} from "./WatchlistDataReviewUtils.js";
import { getWatchlistData } from "./watchlistUtils";
import renderMofsHitDetails from './MofsHitDetails';

const WatchlistDataReview = ({ data, onActionSelect, onActionUndo }) => {
  const watchlistData = getWatchlistData(data);
  return (
    <>
      {renderCardSection(
        watchlistData.fakeEmailDomains,
        "Fake e-mail domains",
        renderAnyHitDetails,
        <>
          SignalCheck — The STM Integrity Hub maintains a list of fake email domains that have been linked to paper mill activities or other serious research integrity violations. These domains were gathered from various sources.
        </>,
        onActionSelect,
        onActionUndo,
        data
      )}
      {renderCardSection(
        watchlistData.fakeAffiliationNames,
        "Fake affiliation names",
        renderAnyHitDetails,
        <>
          SignalCheck — The STM Integrity Hub maintains a list of fake email domains
          and institution names that were involved in paper mill activities. A red
          flag indicates that a match was found.
        </>,
        onActionSelect,
        onActionUndo,
        data
      )}
      {renderCardSection(
        watchlistData.fakeNamesOrEmailAddresses,
        "Fake names or email addresses",
        renderAnyHitDetails,
        <>
          SignalCheck — The STM Integrity Hub maintains a list of fake names or
          email addresses that were involved in paper mill activities. A red flag
          indicates that a match was found.
        </>,
        onActionSelect,
        onActionUndo,
        data
      )}
      {renderCardSection(
        watchlistData.disposableEmailDomains,
        "Disposable e-mail domains",
        renderAnyHitDetails,
        <>
          SignalCheck — The STM Integrity Hub maintains a list of disposable and temporary email address domains
          often used to register dummy users in order to spam or abuse some
          services. See&nbsp;
          <a href="https://github.com/disposable-email-domains/disposable-email-domains">
            https://github.com/disposable-email-domains/disposable-email-domains
          </a>
          .
        </>,
        onActionSelect,
        onActionUndo,
        data
      )}
      {renderCardSection(
        watchlistData.metadataSuspects,
        "Metadata suspects",
        renderAnyHitDetails,
        <>
          SignalCheck – The STM Integrity Hub maintains a list of suspect names that may occur
          in WORD file metadata. These suspect names were identified by participating publishers.
        </>,
        onActionSelect,
        onActionUndo,
        data
      )}
      {renderCardSection(
        watchlistData.manuscriptsOfferedForSale,
        "Manuscripts offered for sale",
        renderMofsHitDetails,
        <>
          SignalCheck — The STM Integrity Hub maintains a list of manuscripts that were previously offered for sale by paper
          mills on specific sites and channels
        </>,
        onActionSelect,
        onActionUndo,
        data
      )}
      {renderCardSection(
        watchlistData.suspectArticles,
        "Suspect articles",
        renderAnyHitDetails,
        null,
        onActionSelect,
        onActionUndo,
        data
      )}
    </>
  );
};

export default WatchlistDataReview;
